export const STATUS = {
    ONLINE: 1,
    OFFLINE: 0,
}
const getEnvVar = (key) => (typeof process !== 'undefined' && process.env && process.env[key]) || undefined;

// Environment detection
const nodeEnv = getEnvVar('NODE_ENV') || 'production';
const isDevelopment = nodeEnv === 'development';
const isProdFlag = getEnvVar('REACT_APP_PROD') === 'true';
const devApiFlag = getEnvVar('REACT_APP_DEV_API');

// Environment Logic:
// 1. NODE_ENV: 'development' or 'production' (standard Node.js env)
// 2. REACT_APP_PROD: 'true' forces production APIs regardless of NODE_ENV (highest priority)
// 3. REACT_APP_DEV_API: 'false' forces production APIs even in development
//
// API Selection Rules (in order of priority):
// - Use production APIs when: REACT_APP_PROD='true' (overrides everything)
// - Use production APIs when: NODE_ENV=production
// - Use production APIs when: REACT_APP_DEV_API='false'
// - Use localhost APIs when: NODE_ENV=development AND REACT_APP_DEV_API !== 'false' AND REACT_APP_PROD !== 'true'

const useLocalhost = isDevelopment && !isProdFlag;
const useProduction = !isDevelopment || isProdFlag;

// API URLs based on environment

const getApiUrl = () => {
    if (useLocalhost) {
        return 'http://localhost:8001';
    }
    return 'https://api.thebeautrium.com';
};

const getStrapiUrl = () => {
    if (useLocalhost) {
        return 'http://localhost:1337';
    }
    return 'https://cms.thebeautrium.com';
};

// Log environment configuration for debugging (always show in server context)
const apiUrl = getApiUrl();
const strapiUrl = getStrapiUrl();

// Log environment configuration for debugging (development only)
if (isDevelopment) {
    console.log('🔧 Environment Configuration:');
    console.log('  NODE_ENV:', nodeEnv);
    console.log('  REACT_APP_PROD:', isProdFlag);
    console.log('  REACT_APP_DEV_API:', devApiFlag);
    console.log('  API_URL (for client):', apiUrl);
    console.log('  STRAPI_API:', strapiUrl);
    console.log('---');
}

export const SOCIAL_KEY = getEnvVar('REACT_APP_SOCIAL_KEY');
export const API_URL = isDevelopment ? getApiUrl() : '/ssr';
export const ROOT_URL = getApiUrl();
export const PUBLIC_URL = 'https://thebeautrium.com';
export const STRAPI_API = getStrapiUrl();

// Log the final exported URLs for debugging (development only)
if (isDevelopment) {
    console.log('📡 Final API URLs being used:');
    console.log('  API_URL (axios baseURL):', API_URL);
    console.log('  ROOT_URL (direct API):', ROOT_URL);
    console.log('  STRAPI_API:', STRAPI_API);
    console.log('---');
}
export const PAYMENT_VERSION = "NEW";
export const PROMPTPAY = "0868885840";
export const KBANK_API = useProduction ?
    "https://kpaymentgateway-services.kasikornbank.com" :
    "https://dev-kpaymentgateway-services.kasikornbank.com";
export const KBANK_PUBLIC_KEY = getEnvVar('REACT_APP_KBANK_PUBLIC_KEY');
export const IP = getApiUrl();
export const BEAUTRIUM_INTRO = "BEAUTRIUM is the most leading beauty multi brand store."
// These are now fallback values - actual values come from delivery reducer
export const DELIVERY_COST = 55;
export const DELIVERY_THRESHOLD = 499;